<template>
  <div>
    <h2>Infos</h2>
    <table v-once v-bind:id=tableId class="dataTable table table-striped table-bordered" width="100%" cellspacing="0">
      <thead>
      <tr>
        <th>ID</th>
        <th>Bezeichnung</th>
        <th>Betroffen</th>
        <th>Optionen</th>
      </tr>
      </thead>
    </table>
    <div>
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
/* global $ */

import TaskService from '../services/TaskService'

export default {
  name: 'Task',
  props: ['id'],
  data () {
    return {
      // eslint-disable-next-line no-undef
      tableId: (this.$props.id !== undefined) ? 'dTable_' + this.$func.uuid() + '_' + this.$props.id : 'dTable_' + this.$func.uuid()
    }
  },
  computed: {},
  async mounted () {
    var path = '/task/task'
    var router = this.$router
    var tableId = this.tableId
    var self = this

    var tmp = await TaskService.getUserOptions()
    var personenkreise = tmp.data

    this.$func.loadDatatable(
      () => $(document).ready(function () {
        var userOpts = {
          plugins: ['remove_button'],
          maxItems: null,
          valueField: 'idval',
          searchField: ['sFirstname', 'sLastname', 'sBezeichnung', 'personenkreisName'],
          placeholder: 'Personenkreis wählen ...',
          preload: true,
          options: [],
          sortField: [{
            field: 'personenkreisType',
            direction: 'asc'
          }, {
            field: 'sBezeichnung',
            direction: 'asc'
          }, {
            field: 'sLastname',
            direction: 'asc'
          }, {
            field: 'sFirstname',
            direction: 'asc'
          }, {
            field: '$score'
          }],
          create: false,
          render: {
            option: function (data, escape) {
              var str = ''
              if ((data.personenkreisType) === 0) {
                str = escape(data.sLastname) + ', ' + escape(data.sFirstname)
              } else {
                str = escape(data.sBezeichnung)
              }
              // eslint-disable-next-line no-unused-vars
              var str2 = escape(data.personenkreisName)
              // eslint-disable-next-line no-unused-vars
              var txt = '<div><span>' + str + '</span>'
              txt = txt + '<br><span style="opacity: 0.5;">' + str2 + '</span>'
              txt = txt + '</div>'
              return txt
            },
            item: function (item, escape) {
              var str = ''
              if ((item.personenkreisType) === 0) {
                str = escape(item.sLastname) + ', ' + escape(item.sFirstname)
              } else {
                str = escape(item.sBezeichnung)
              }

              // eslint-disable-next-line no-unused-vars
              var str2 = escape(item.personenkreisName)
              var txt = '<div><span>' + str + '</span>'
              txt = txt + '<br><span style="opacity: 0.5;">' + str2 + '</span>'
              txt = txt + '</div>'
              return txt
            }
          },
          load: function (query, callback) {
            callback(personenkreise)
          }
        }

        var editor = new $.fn.dataTable.Editor({
          ajax: {
            create: self.$func.addAuth({
              type: 'POST',
              url: path + '/'
            }),
            edit: self.$func.addAuth({
              type: 'PUT',
              url: path + '/_id_/'
            }),
            remove: self.$func.addAuth({
              type: 'DELETE',
              url: path + '/_id_/',
              deleteBody: false
            }),
            upload: self.$func.addAuth({
              type: 'POST',
              url: '/file/?origin=' + path
            })
          },
          idSrc: 'id',
          table: '#' + tableId,
          fields: [
            {
              label: 'Bezeichnung:',
              name: 'sBezeichnung'
            },
            {
              label: 'Text:',
              name: 'sText',
              type: 'textarea'
            },
            {
              label: 'Betroffen:',
              name: 'oZustaendigkeit_arr',
              type: 'selectize',
              opts: userOpts
            },
            {
              label: 'Typ:',
              name: 'oTaskType',
              type: 'hidden'
            },
            {
              label: 'Modus:',
              name: 'lZustaenigkeitsModus',
              type: 'hidden'
            }, {
              label: 'Anhänge:',
              name: 'fFiles[].id',
              type: 'uploadMany',
              display: function (fileId, counter) {
                if (!$.isNumeric(fileId)) {
                  return fileId.toString().split('###')[0]
                }

                return fileId
              },
              uploadText: 'Dateien auswählen',
              dragDropText: 'oder die Dateien hier hinein ziehen.',
              noFileText: 'Dateien sind im Dateimanager abrufbar'
            }
          ]
        })

        editor
          .on('preOpen', function () {
            editor.set('oTaskType', 99)
            editor.set('lZustaenigkeitsModus', 2)
          })

        $('#' + tableId).DataTable({
          dom: 'BfQrtip', // BUTTON/FIND/PROCESSING/TABLE/INFO/PAGING
          ajax: self.$func.addAuth({
            url: path + '/type/99/',
            type: 'GET'
          }),
          scrollX: true,
          scrollCollapse: true,
          columns: [
            {
              class: 'center',
              data: 'id'
            },
            {
              class: 'center',
              data: 'sBezeichnung'
            },
            {
              class: 'center',
              data: null,
              render: function (data, type, row) {
                var strArr = [];
                (data.oZustaendigkeit_arr).forEach(function (element) {
                  strArr.push(element.sName)
                })
                return strArr.join(', <br>')
              }
            },
            {
              class: 'center not-export-col',
              data: null,
              render: function (data, type, row) {
                // eslint-disable-next-line no-unused-vars
                var files = '<i title="Dateien" class="dt-files fas fa-paperclip fa-lg pointer"></i>'

                return files
              }
            }
          ],
          initComplete: function (settings, json) {
            // $('#' + tableId).DataTable().searchPanes.rebuildPane()
          },
          buttons: self.$func.addDefaultButtons([
            {
              extend: 'create',
              editor: editor
            },
            {
              extend: 'edit',
              editor: editor
            },
            {
              extend: 'remove',
              editor: editor
            }
          ])
        })

        $('#' + tableId).on('click', '.dt-files', function (e) {
          e.preventDefault()
          var tr = $(this).closest('tr')
          var row = $('#' + tableId).DataTable().row(tr)
          var id = row.data().id

          router.push({
            name: 'infofiles',
            params: {
              id: id,
              context: 'info',
              contextpath: 'task/task',
              payload: row.data()
            }
          })
        })

        $('#' + tableId + ' tbody').on('dblclick', 'tr', function () {
          editor
            .edit(this)
            .title($.fn.dataTable.Editor.defaults.i18n.edit.title)
            .buttons({
              label: $.fn.dataTable.Editor.defaults.i18n.edit.submit,
              className: 'btn btn-primary',
              fn: function () {
                editor.submit()
              }
            })
        })
      }))
  }
}
</script>

<style scoped>

</style>
